/**
 * interface defines tracking numbers
 */
export interface TrackingNumber {
    carrier_name: string;
    /** carrier slug as returned by the tracking provider; compared against UNKNOWN_SLUG */
    slug?: string;
    number: string;
    status: string;
    url: string;
    mode?: string;
    shipping_date?: Date;
    quantity?: number;
    sku_number?: string;
}


// constant for unknown slug
export const UNKNOWN_SLUG = 'unknown';


